/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Refund_Exceeds_CreditInputs */

const vi_error_refund_exceeds_credit = /** @type {(inputs: Error_Refund_Exceeds_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền hoàn vượt tiền dư hiện có của khách.`)
};

/**

* @param {Error_Refund_Exceeds_CreditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_refund_exceeds_credit = /** @type {((inputs?: Error_Refund_Exceeds_CreditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Refund_Exceeds_CreditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_refund_exceeds_credit(inputs)
});